module.exports = __webpack_public_path__ + "img/scene-face-manipulation.b9bc3963.jpg";